var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_93",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749023 0H26.749V26H0.749023V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7172 18.8397L10.0563 15.963C9.96319 15.8017 10.0181 15.595 10.1794 15.5017C10.7826 15.153 11.5543 15.3596 11.9027 15.9629L12.1712 16.428V12.0288C12.1712 11.5873 12.5291 11.2293 12.9707 11.2293C13.4123 11.2293 13.7702 11.5873 13.7702 12.0288V11.5123C13.7702 11.0788 14.1073 10.7096 14.5405 10.6942C14.9954 10.678 15.3692 11.0419 15.3692 11.4932V12.0288C15.3692 11.5873 15.7271 11.2293 16.1687 11.2293C16.6103 11.2293 16.9682 11.5873 16.9682 12.0288V13.0969C16.9682 12.6554 17.3262 12.2974 17.7677 12.2974C18.2093 12.2974 18.5672 12.6554 18.5672 13.0969V18.7711C18.5672 19.5101 18.3166 20.1904 17.8957 20.732C17.6342 21.0684 17.4951 21.4838 17.4951 21.91L17.4949 24.2386C17.4949 24.3392 17.4134 24.4207 17.3129 24.4207H13.4256C13.325 24.4207 13.2435 24.3392 13.2435 24.2386L13.2433 21.9095C13.2433 21.4858 13.1075 21.0711 12.8468 20.737C12.7699 20.6385 12.6987 20.5354 12.6336 20.4282",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9683 15.6125V13.0968",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3691 15.6125V12.0287",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7703 15.6125V12.0287",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9445 6.37301L14.7659 7.63086",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7438 7.75789L14.6401 9.5498",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5434 9.14253L15.4397 10.9344",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95459 11.0134L11.1332 12.2712",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75415 9.62866L12.6457 11.2981",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5537 8.24373L13.6574 10.0356",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9318 8.3247L23.1989 7.86214C23.2941 7.70807 23.3756 7.54674 23.4431 7.38002C23.6021 6.98723 23.8933 6.66228 24.2602 6.45037L26.2772 5.2857C26.3643 5.23543 26.3941 5.12406 26.3438 5.03692L24.4002 1.67043C24.3499 1.58339 24.2385 1.55353 24.1515 1.6038L22.1348 2.76802C21.7657 2.98104 21.3363 3.06823 20.9142 3.00999C20.2348 2.9163 19.5203 3.03944 18.8804 3.40893L13.9664 6.24597C13.584 6.46677 13.453 6.95574 13.6738 7.33813C13.8945 7.72056 14.3835 7.85158 14.7659 7.63078L13.8408 8.1649C13.4584 8.38564 13.3274 8.87461 13.5482 9.257C13.769 9.63943 14.2579 9.7704 14.6403 9.54965L14.1764 9.81747C13.7857 10.0431 13.6574 10.5488 13.8988 10.9346C13.9134 10.958 13.9292 10.9803 13.9458 11.0016",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9585 11.904L20.049 10.1196L19.7805 10.5847C19.4322 11.1881 19.6391 11.9597 20.2428 12.3077C20.4042 12.4008 20.6106 12.345 20.7038 12.1837L22.0279 9.89019",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80283 4.85232H7.11713C6.93615 4.84693 6.75557 4.85694 6.57748 4.88187C6.15782 4.94062 5.7308 4.85089 5.36381 4.63909L3.34668 3.47462C3.25959 3.42435 3.14822 3.45421 3.09795 3.5413L1.1543 6.90779C1.10402 6.99488 1.13388 7.10624 1.22097 7.15652L3.23755 8.32093C3.60657 8.53401 3.89679 8.86226 4.05741 9.25698C4.31594 9.8922 4.77988 10.4494 5.41977 10.8189L10.3338 13.656C10.7162 13.8767 11.2051 13.7457 11.4259 13.3633C11.6467 12.9809 11.5157 12.4919 11.1333 12.2712L12.0583 12.8053C12.0951 12.8264 12.1328 12.8444 12.1711 12.8592",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7375 8.2356L10.6469 6.45124H11.184C11.8807 6.45124 12.4454 5.8862 12.445 5.18943C12.4449 5.00312 12.2934 4.85224 12.1071 4.85224H9.58008",
    stroke: "white",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.5ea0451df78222002d7ab64c2a766cfb.svg";
export { ForwardRef as ReactComponent };